// extracted by mini-css-extract-plugin
export default {"text":"Text_text__0QjN9","fontFamilyAvenir":"Text_fontFamilyAvenir__6X7dC","fontFamilyLato":"Text_fontFamilyLato__QK-7n"};